import TYPES from '@/modules/shared/types';

// Domain
import { AssociatedProductRepository } from '../../domain/repositories/associated-product-repository';
import { AssociatedProductEntity } from '../../domain/entities/associated-product-entity';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class AssociatedProductHttpRepository implements AssociatedProductRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/flagship/investor-goal/associated-product/{associated_product_id}/`;

  get(associated_product_id: string): Promise<Array<AssociatedProductEntity>> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint.replace('{associated_product_id}', associated_product_id))
        .then((response) => {
          response.json()
            .then(({ success, data, error }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(error));
              }
            });
        })
        .catch(reject);
    });
  }
}
